module.exports = __webpack_public_path__ + "static/media/3.66fa4b5b.png";